// Alexis Cargo Me landing page — interactions added as sections are built.

(function () {
  var COLOR_LABELS = {
    navy: 'Navy',
    'light-blue': 'Light Blue',
    green: 'Green',
    gray: 'Gray',
    black: 'Black'
  };

  function toCamelCase(str) {
    return str.replace(/-([a-z])/g, function (_, c) {
      return c.toUpperCase();
    });
  }

  document.querySelectorAll('.ax-features__swatches').forEach(function (group) {
    var section = group.closest('.ax-features');
    if (!section) return;

    var image = section.querySelector('[data-color-image]');
    var label = section.querySelector('[data-color-label]');
    var titleJumbo = section.querySelector('.ax-features__title-jumbo');
    var swatches = group.querySelectorAll('[data-color-swatch]');

    function applyColor(swatch) {
      var color = swatch.getAttribute('data-color-swatch');
      var key = toCamelCase(color);

      swatches.forEach(function (s) {
        s.classList.remove('is-active');
      });
      swatch.classList.add('is-active');

      if (image && image.dataset[key]) {
        image.setAttribute('src', image.dataset[key]);
        image.setAttribute('alt', 'กระเป๋า Alexis Cargo Me สี ' + (COLOR_LABELS[color] || color));
      }

      if (label) {
        label.textContent = COLOR_LABELS[color] || color;
      }

      if (titleJumbo) {
        titleJumbo.style.color = getComputedStyle(swatch).backgroundColor;
      }
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        applyColor(swatch);
      });
    });

    var activeSwatch = group.querySelector('[data-color-swatch].is-active') || swatches[0];
    if (activeSwatch) applyColor(activeSwatch);
  });

  document.querySelectorAll('.ax-qa__item').forEach(function (item) {
    var button = item.querySelector('.ax-qa__question');
    if (!button) return;

    button.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');

      item.parentElement.querySelectorAll('.ax-qa__item').forEach(function (sibling) {
        sibling.classList.remove('is-open');
        var siblingButton = sibling.querySelector('.ax-qa__question');
        if (siblingButton) siblingButton.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
      }
    });
  });

  var stickyCta = document.getElementById('ax-sticky-cta');
  var surveySection = document.getElementById('survey');

  if (stickyCta && surveySection) {
    var updateStickyCta = function () {
      var pastSurvey = window.scrollY > surveySection.offsetTop + surveySection.offsetHeight;

      if (pastSurvey) {
        stickyCta.classList.add('is-visible');
      } else {
        stickyCta.classList.remove('is-visible');
      }
    };

    window.addEventListener('scroll', updateStickyCta, { passive: true });
    updateStickyCta();
  }

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!reduceMotion && 'IntersectionObserver' in window) {
    var revealSelector = [
      '.ax-survey__intro',
      '.ax-survey__embed-wrap',
      '.ax-pain__card',
      '.ax-features__intro',
      '.ax-features__showcase',
      '.ax-features__picker',
      '.ax-features__grid',
      '.ax-lifestyle__sticky',
      '.ax-details__intro',
      '.ax-details__diagram',
      '.ax-qa__intro',
      '.ax-qa__accordion'
    ].join(', ');

    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll(revealSelector).forEach(function (el) {
      revealObserver.observe(el);
    });
  }
}());

// "ใส่ใจทุกดีเทล" callouts: on narrow screens (<= 1359px) the four items become tabs
// (circular photos switch the text panel). On wider screens all four show with leader lines.
(function () {
  var root = document.querySelector('.ax-co');
  if (!root) return;
  var tabs = Array.prototype.slice.call(root.querySelectorAll('.ax-co__tab'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('.ax-co__item'));
  if (!tabs.length || tabs.length !== panels.length) return;

  var mq = window.matchMedia('(max-width: 1359px)');
  var current = 0;

  function select(index, focus) {
    current = index;
    tabs.forEach(function (tab, i) {
      var on = i === index;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
    });
    panels.forEach(function (panel, i) {
      panel.classList.toggle('is-active', i === index);
    });
    if (focus) tabs[index].focus();
  }

  function apply() {
    if (mq.matches) {
      root.classList.add('js-tabs');
      panels.forEach(function (panel) { panel.setAttribute('role', 'tabpanel'); });
      select(current, false);
    } else {
      root.classList.remove('js-tabs');
      panels.forEach(function (panel) { panel.removeAttribute('role'); });
      tabs.forEach(function (tab) { tab.removeAttribute('tabindex'); });
    }
  }

  tabs.forEach(function (tab, i) {
    tab.addEventListener('click', function () { select(i, false); });
    tab.addEventListener('keydown', function (e) {
      var next = null;
      if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
      else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = tabs.length - 1;
      if (next !== null) {
        e.preventDefault();
        select(next, true);
      }
    });
  });

  if (mq.addEventListener) mq.addEventListener('change', apply);
  else if (mq.addListener) mq.addListener(apply);
  apply();
})();

// Callouts: entrance animation when the block scrolls into view + hover/focus highlight (desktop).
// Without this script, or with reduced motion, the callouts are simply shown.
(function () {
  var root = document.querySelector('.ax-co');
  if (!root) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var wide = window.matchMedia('(min-width: 1360px)');

  // --- entrance ---
  if (!reduce && 'IntersectionObserver' in window) {
    root.classList.add('js-anim');
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        root.classList.add('is-in');
        obs.unobserve(root);
        // after the staggered entrance (~2.4 s) hover reactions should not inherit the delays
        window.setTimeout(function () { root.classList.add('is-settled'); }, 2600);
      });
    }, { threshold: 0.25 });
    io.observe(root);
  }

  // --- hover / focus highlight (wide screens only) ---
  function setActive(n) {
    if (!wide.matches) return;
    if (n) root.setAttribute('data-active', n);
    else root.removeAttribute('data-active');
  }

  root.querySelectorAll('.ax-co__text, .ax-co__pic, .ax-co__lines circle').forEach(function (el) {
    var n = el.getAttribute('data-co');
    if (!n) return;
    el.addEventListener('mouseenter', function () { setActive(n); });
    el.addEventListener('mouseleave', function () { setActive(null); });
  });

  var onChange = function () { if (!wide.matches) root.removeAttribute('data-active'); };
  if (wide.addEventListener) wide.addEventListener('change', onChange);
  else if (wide.addListener) wide.addListener(onChange);
})();
